const imagesArray = [
  require("../assets/sprite-generic/Statua_030.jpg"),
  require("../assets/sprite-generic/Statua_031.jpg"),
  require("../assets/sprite-generic/Statua_032.jpg"),
  require("../assets/sprite-generic/Statua_033.jpg"),
  require("../assets/sprite-generic/Statua_034.jpg"),
  require("../assets/sprite-generic/Statua_035.jpg"),
  require("../assets/sprite-generic/Statua_036.jpg"),
  require("../assets/sprite-generic/Statua_037.jpg"),
  require("../assets/sprite-generic/Statua_038.jpg"),
  require("../assets/sprite-generic/Statua_039.jpg"),
  require("../assets/sprite-generic/Statua_040.jpg"),
  require("../assets/sprite-generic/Statua_041.jpg"),
  require("../assets/sprite-generic/Statua_042.jpg"),
  require("../assets/sprite-generic/Statua_043.jpg"),
  require("../assets/sprite-generic/Statua_044.jpg"),
  require("../assets/sprite-generic/Statua_045.jpg"),
  require("../assets/sprite-generic/Statua_046.jpg"),
  require("../assets/sprite-generic/Statua_047.jpg"),
  require("../assets/sprite-generic/Statua_048.jpg"),
  require("../assets/sprite-generic/Statua_049.jpg"),
  require("../assets/sprite-generic/Statua_050.jpg"),
  require("../assets/sprite-generic/Statua_051.jpg"),
  require("../assets/sprite-generic/Statua_052.jpg"),
  require("../assets/sprite-generic/Statua_053.jpg"),
  require("../assets/sprite-generic/Statua_054.jpg"),
  require("../assets/sprite-generic/Statua_055.jpg"),
  require("../assets/sprite-generic/Statua_056.jpg"),
  require("../assets/sprite-generic/Statua_057.jpg"),
  require("../assets/sprite-generic/Statua_058.jpg"),
  require("../assets/sprite-generic/Statua_059.jpg")
]

export {
  imagesArray
};